module.exports = __webpack_public_path__ + "static/media/allenSolly.f945de39.svg";